import { Dialog, MenuItem,Select,Box,InputLabel,Stack, TextField,Tooltip, IconButton, Autocomplete,Typography } from "@mui/material";
import { useState,useEffect } from "react";
import { fetchMeta } from '../supabaseApi'

const InfoModal = ({modalOpen,handleInfoModal})=>{
  const [meta,setMeta] = useState([])
  const [loading,setLoading] = useState(false)

  useEffect(async()=>{
    if (!modalOpen) return
    setLoading(true)
    try {
      let res = await fetchMeta()
      console.log(res)
      setMeta(res)
    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  },
  [modalOpen])
    
    return <Dialog 
    open={modalOpen}
    onClose={handleInfoModal}
    sx={{cursor:(loading ? 'wait' : 'pointer' )}}
    >
   
    <Box sx={{display:'flex',justifyContent:'center'}} p={4}>
        
 <Typography>
  {meta?.about}
 </Typography>
    </Box>
    
        </Dialog>

}

export default InfoModal